
function Vision() {
    return (
  
        <div>

            <div className="boxCustomization">
                <p className="componentTitle"> Vision </p>
                <p className="componentText"> Advanced Research Centre For Sustainable Energy Technologies (ARCSET) seeks to catalyze
                progress in the development of innovative and scalable technologies that will support
                the transition to the adoption of clean energy across the global landscape. The Centre
                envisions delivering pioneering solutions to tackle challenges where energy will play
                an essential role in holistically advancing the pathway to a sustainable future in India
                and around the world. </p>
            </div>

            <div className="boxCustomization">
                <p className="componentTitle secondaryTitle"> Mission </p>
                <p className="componentText"> The Mission of the Advanced Research Centre For Sustainable Energy Technologies
                (ARCSET) is to foster a sustainable energy future by supporting research, education,
                innovation, collaboration, and entrepreneurship in advanced energy technologies. The
                Centre is dedicated to developing and implementing affordable, cutting-edge solutions
                that will reduce carbon emissions, enhance energy security, and ensure equitable
                access to sustainable energy resources. Through a multidisciplinary approach, ARCSET
                will leverage the expertise of BITS Pilani faculty and engage external leaders from
                academia and industry to tackle complex energy challenges and drive transformative
                advancements in sustainable energy. </p>
            </div>
            

            <div className="boxCustomization">
                <p className="componentTitle secondaryTitle"> Objectives </p>
                <p className="componentText">1. To establish an inter-campus, interdisciplinary research and development team
                encompassing basic sciences, engineering, humanities, economics, and policy
                disciplines, leveraging BITS Pilani's unique position in interdisciplinary expertise to
                advance energy and environmental research.<br/><br/>
                2. To advance early-stage, science-driven proof-of-concept research at lower
                Technology Readiness Levels (TRLs), enabling pathways for potential scale-up and
                implementation of developed technologies.<br/><br/>
                3. To develop industry-relevant solutions in energy and climate change by conducting
                applied research that addresses critical challenges in the industrial sector and
                ensure real-world impact through partnerships with industry stakeholders.<br/><br/>
                4. To support entrepreneurial initiatives by co-opting startup entrepreneurs, especially
                those originating from within BITS Pilani and including external entrepreneurs to
                foster innovation and commercialization of sustainable energy solutions.<br/><br/>
                5. To develop a specialized sub-center focused on the advancement of new and
                advanced materials for energy transition, equipped with state-of-the-art facilities for
                synthesis, testing and characterization within the existing campus infrastructure.<br/><br/>
                6. To prioritize skill development and capacity building by engaging graduate, postgraduate, and doctoral students, along with post-doctoral researchers, creating a
                pipeline of skilled experts in sustainable energy.<br/><br/>
                7. To integrate policy research and economic analysis through collaborations with
                economists, developing Life Cycle Assessment (LCA) and forecasting models, and
                leveraging expertise from mathematics, humanities, economics, and management
                disciplines to support sustainable energy policy development.<br/><br/>
                8. To facilitate international collaboration and outreach by building alliances with
                global bodies and engaging in initiatives that promote knowledge-sharing and
                sustainable energy practices on a global scale. </p>
            </div>


        </div>
        
    );
}
  
  export default Vision;